import { API_KEY } from 'environmentConstants'

export const API = {
  TOKEN: API_KEY,
  BASE: '/r',
  COMPANIES: '/r/companies',
  COMMON: '/r/api/common',
  RESPONSE: 'responses'
}

export const API_RESOURCE_TYPE = {
  MARKS: 'marks'
}

export const KeyCodes = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
}

export const Date = {
  SHORT: 'M/D/YY',
  MEDIUM: 'MMM D, YYYY',
  LONG: 'MMMM D, YYYY',
  SPECIAL: 'MMMM YYYY'
}

export const DateTime = {
  MEDIUM: 'MMM D, YYYY h:mma'
}

export const DEFAULT_PER_PAGE = 30

export const BLACKLISTED_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'bing.com',
  'aol.com',
  'msn.com',
  'comcast.net',
  'hotmail.com',
  'outlook.com'
]

export const DraggableTypes = {
  TAG_LIST_ITEM: 'tagListItem'
}

export const TaxonomyManager = {
  CHEVRON_WIDTH: 24,
  ROW_PADDING: 10,
  ROW_WIDTH: 978,
  CHECKBOX_WIDTH: 30,
  TAG_COUNT_WIDTH: 152,
  TAG_ACTIONS_WIDTH: 100
}

export const TooltipText = {
  SEARCH:
    'Advanced search is available with a subscription. ' +
    'It lets you hone in on content based on project ' +
    "characteristics or any custom tags that you've " +
    'defined.',
  DESIGN: 'Adjusting Project Information is available with a subscription.',
  COLLECTION: 'This element can be used with a subscription.',
  WORKSPACE:
    'Creating workspaces & reports such as highlight pages and ' +
    'playlists are available with a subscription.',
  ANALYZE:
    'Analysis tools (video tagging, clipping, and more) are available ' +
    'with a subscription.',
  DEFAULT: 'This element can only be used with a subscription.'
}

export const TooltipLink = {
  SEARCH:
    'https://support.focusvision.com/Video_Insights/Search/Advanced_Search',
  DESIGN:
    'https://support.focusvision.com/Video_Insights/Project_Management/Project_Design',
  COLLECTION:
    'https://support.focusvision.com/Video_Insights/Project_Management/003_Collection_Status_Page',
  WORKSPACE:
    'https://support.focusvision.com/Video_Insights/Workspaces/Workspaces',
  ANALYZE:
    'https://support.focusvision.com/Video_Insights/Project_Management/Analyzing_Videos'
}

export const UpgradeLink =
  'https://support.focusvision.com/Video_Insights/Additional_Information/Upgrade'



// WEBPACK FOOTER //
// ../src/constants/appConstants.js